import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://huvzikgbokzmdafqgpqq.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1dnppa2dib2t6bWRhZnFncHFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5Mjg4NjcsImV4cCI6MjA4NjUwNDg2N30.VO1KbYKFsWrEk02gQhzQ11ZNs9nYajwG3o6a4bB-K0Y';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Disable navigator.locks to prevent "The lock request is aborted" errors in restricted environments
    storageKey: 'villa-avoils-auth',
  }
});